import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import axios from "axios"
import { useHistory } from "react-router-dom"

const HistoryModal = ({ HistoryModalToggle, selectedReport, setAuth }) => {
  // console.log("selectedReport", selectedReport)

  const history = useHistory()

  //************* form control ******/
  const [modal, setmodal] = useState(true)
  const toggle = () => {
    HistoryModalToggle()
  }
  const onClose = () => {
    HistoryModalToggle()
  }

  // *********************** Fetch users data ******************************** //
  const [users, setUsers] = useState([])
  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
    }

    // axios
    //   .post(process.env.REACT_APP_API_URL + "api/MenuUsersView", formData)
    //   .then(res => {
    //     if (res.data.error === true && res.data.message === "Access denied!") {
    //       setAuth(true)
    //       setTimeout(() => {
    //         history.push("/logout")
    //         setTimeout(() => {
    //           history.push("/login")
    //         }, 1000)
    //       }, 4000)
    //     }

    //     let data = Object.values(res.data)
    //     data.splice(-1)
    //     let dataUsers = data.map(user => ({
    //       value: user.UserID,
    //       label: `${user.FirstName} ${user.LastName}`,
    //     }))
    //     setUsers(dataUsers)
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
  }, [])

  return (
    <Modal isOpen={modal} toggle={toggle} className="modal-md">
      <ModalHeader>
        Request No: 214587549
        <button
          type="button"
          className="btn-close position-absolute end-0 top-0 m-3"
          onClick={onClose}
        />
      </ModalHeader>

      <ModalBody>
        <Table className="project-list-table table-nowrap text-center align-middle table-borderless">
          <thead>
            <tr>
              <th scope="col" style={{ width: "20px" }}>
                #
              </th>

              <th scope="col">Date</th>
              <th scope="col">Rev</th>
              <th scope="col">status</th>
              <th scope="col">Res. Person</th>
            </tr>
          </thead>
          {/***********table body *****************/}
          <tbody></tbody>
        </Table>
      </ModalBody>
    </Modal>
  )
}

export default HistoryModal
